import { NavLink, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useState } from "react";

const NAV = [
  { to: "/", label: "Home", num: "01" },
  { to: "/about", label: "About Us", num: "02" },
  { to: "/projects", label: "Projects", num: "03" },
  { to: "/links", label: "Links", num: "04" },
  { to: "/service", label: "Service", num: "05" },
  { to: "/contact", label: "Contact", num: "06" },
];

export default function Taskbar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Taskbar */}
      <motion.nav
        data-testid="main-taskbar"
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
        className="fixed top-0 left-0 right-0 z-50 h-14 bg-black/70 backdrop-blur-xl border-b border-white/10"
      >
        <div className="h-full w-full flex items-center justify-between px-4 md:px-6">
          <Link
            to="/"
            data-testid="brand-logo-link"
            className="flex items-center gap-3 group"
          >
            <img
              src="/assets/anron_logo_light.png"
              alt="Anron"
              className="h-6 md:h-7 w-auto"
            />
          </Link>

          {/* Desktop nav */}
          <ul className="hidden md:flex items-center gap-1">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.to === "/"}
                  data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    `group relative flex items-center gap-2 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors duration-500 ${
                      isActive ? "text-white" : "text-white/55 hover:text-white"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <span>{item.label}</span>
                      <span
                        className={`absolute left-3 right-3 -bottom-[1px] h-px bg-white origin-left transition-transform duration-500 ${
                          isActive ? "scale-x-100" : "scale-x-0 group-hover:scale-x-100"
                        }`}
                      />
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Mobile menu button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((o) => !o)}
            className="md:hidden font-mono text-[11px] uppercase tracking-[0.18em] border border-white/20 px-3 py-1.5"
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>
      </motion.nav>

      {/* Mobile drawer */}
      <div
        className={`fixed inset-0 z-40 bg-black transition-opacity duration-500 md:hidden ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        data-testid="mobile-menu-drawer"
      >
        <div className="h-full flex flex-col justify-center px-8 gap-6 pt-24">
          {NAV.map((item, i) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-baseline gap-4 border-b border-white/10 pb-4 font-display text-5xl ${
                  isActive ? "text-white" : "text-white/70"
                }`
              }
            >
              <span className="font-mono text-xs text-white/40">{item.num}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
}
